// extracted by mini-css-extract-plugin
export default {"rating":"uL-z","numberOfStars":"vL-z","count":"wL-z","barGraphSpacing":"xL-z","barGraph":"yL-z"};